"house-ofchikankari.myshopify.com" == Shopify.shop && die(),
 (window.icallofzColl = 1);

var zooomyColl = function (o) {
 var t = document.querySelectorAll(".zoomywishid");
 const scriptElement = document.getElementById("ZooomyCollScript");
 const shopId = scriptElement
   ? scriptElement.getAttribute("data-shop-id")
   : null;
 const customerId = scriptElement
   ? scriptElement.getAttribute("data-cus-id")
   : null;
 const customerEmail = scriptElement
   ? scriptElement.getAttribute("data-cus-email")
   : null;
 const customerName = scriptElement
   ? scriptElement.getAttribute("data-cus-name")
   : null;

 if (icallofzColl > 1) return !1;
 console.log("...."), (window.$ = o);
 var e = t.length,
   i = e,
   a = document.location.href,
   s = a.includes("login");
 0 == s && (s = a.includes("register")),
   0 == s && (s = a.includes("challenge")),
   0 == s && (s = a.includes("account")),
   0 == s && (s = a.includes("cart")),
   0 == s && (s = a.includes("pages")),
   0 == s && (s = a.includes("blog")),
   0 == s && (s = a.includes("policies")),
   $("#zooomy-wishlist-counter").length && (e = 1),
   s && (e = 1);
 var l = "";
 if (0 == e) return !1;
 {
   icallofzColl++;
   let n = 1;
   
   if (window.zoomyHandlersInitialized) {
     $("body").off("click", ".zoomywishid");
     $("body").off("click", ".zoomycheck");
     $("body").off("click", "#zloginrequestclose");
   }
   
   window.zoomyHandlersInitialized = true;
   
   function r(o) {
     var t = [],
       e = "";
     let a = $(".zoomywishid:not([data-zooomy-initialized])");
     $(a).each(function () {
       "" == $(this).html().trim() &&
         ((e = $(this).attr("data-product-id")), t.push(e));
     });
     
     $(a).attr("data-zooomy-initialized", "true");
     
     if (t.length === 0) return;

     var m = btoa(customerEmail || "");

     if (
       ((l =
         "https://zooomyapps.com/wishlist/Coll.php?shop=" +
         shopId +
         "&customerid=" +
         customerId +
         "&WishIdsArray=" +
         t +
         "&ifruncode=" +
         i),
       "" == customerId)
     ) {
       l =
         "https://zooomyapps.com/wishlist/Coll.php?shop=" +
         shopId +
         "&customerid=" +
         customerId +
         "&WishIdsArray=&ifruncode=" +
         i;
     }

     $.ajax({
       url: l,
       data: {},
       dataType: "jsonp",
       jsonp: "jsonCode",
       async: "true",
       success: function (t) {
         var e = t.custom_css,
           i = t.user_added_css,
           s = (t.empty, t.itemadded, t.coll_f_color),
           l = t.coll_e_color,
           n = t.login_text,
           c = t.shop,
           d = t.totalv,
           h = t.wish_icon;
         null == t.l_f_color &&
           ((t.l_f_color = "#000"),
           (t.l_b_color = "#a4dfc7"),
           (t.l_br_color = "#277f4e")),
           $("#zooomy-wishlist-counter").length &&
             $("#zooomy-wishlist-counter span").replaceWith(
               "<span>" + d + "</span>"
             ),
           $(".zooomyIconval").length &&
             d > 0 &&
             $(".zooomyIconval i.fa")
               .addClass("fa-heart")
               .removeClass("fa-heart-o"),
           $(
             '<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css">'
           ).appendTo("body"),
           "yes" == t.w_login &&
             ($("body").append(
               '<a class="zooomy__hhrt" href="/pages/' +
                 t.p_link +
                 '" style="position:fixed;bottom:100px;right:10px;width:48px; height:48px; line-height: 52px; border-radius: 100px; text-align: center; font-size: 20px;"><i class="fa fa-' +
                 h +
                 '"></i></a>'
             ),
             $(
               "<style>.zooomy__hhrt{z-index:9999;background:" +
                 s +
                 "!important;color:" +
                 t.add_font_color +
                 "!important;}</style>"
             ).appendTo("body")),
           $(
             "<style>body{position:relative;}.zoomywishid { width:100%;float: left;  padding: 0; }.zoomywishidheart { float: left; width: 100%; }.zooomywishmsg:hover .collnoitem {  }.zooomywishmsg .fa{margin-right:3px;}.zoomywishid .fa { font-size: 18px; }.zoomycheck{position:absolute;visibility:hidden;}p.zooomywishmsg .fa{margin:0; padding:2px 10px;margin:0;}p.collnoitem { float: left; width: 100%; padding: 10px 0; margin:0; }p.zooomywishmsg.zrmvbg{color:" +
               l +
               "}p.zooomywishmsg.zadbg{color:" +
               s +
               "}.zwishoverlay { z-index:99999;position: fixed; top: 0; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.7); transition: opacity 500ms; display: none; opacity: 0; } .zwishoverlay:target { display: block; opacity: 1; } .zwishlistmodal {  padding: 20px; border-radius: 5px; width: 30%; position: relative; transition: all 5s ease-in-out; } .zwishlistmodal h2 { margin-top: 0; color: #333; font-family: Tahoma, Arial, sans-serif; } .zwishlistmodal .close { position: absolute; top: 20px; right: 30px; transition: all 200ms; font-size: 30px; font-weight: bold; text-decoration: none; color: #333; } .zwishlistmodal .close:hover { color: #06D85F; } .zwishlistmodal .content { max-height: 30%; overflow: auto; } @media screen and (max-width: 700px){ .zwishlistmodal{ width: 70%; } }</style>"
           ).appendTo("body"),
           $("<style>" + e + "</style>").appendTo("body"),
           $("<style>" + i + "</style>").appendTo("body");
         var p = {};
         if (
           ("free" != t.app_plan &&
             (0 == a.length ||
               $(a).each(function () {
                 var o = $(this).attr("data-product-id");
                 if ("yes" == t.itemadded[o])
                   e =
                     "<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
                     o +
                     "' class='zoomycheck checkbox-" +
                     o +
                     "'   id='checkbox-" +
                     o +
                     "'/><label for ='checkbox-" +
                     o +
                     "'><p class='zooomywishmsg zooomywishmsg-" +
                     o +
                     "'><i class='fa fa-" +
                     h +
                     "' style='color: " +
                     s +
                     ";'></i></p></label</div>";
                 else
                   var e =
                     "<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
                     o +
                     "' class='zoomycheck checkbox-" +
                     o +
                     "' id='checkbox-" +
                     o +
                     "'/><label for ='checkbox-" +
                     o +
                     "'><p class='zooomywishmsg zooomywishmsg-" +
                     o +
                     "'><i class='fa  fa-" +
                     h +
                     "-o' style='color: " +
                     l +
                     ";'></i></p></label</div>";
                 $(".zoomywishid-" + o).html(e);
               })),
           "" == customerId)
         )
           if ("yes" == t.w_login) {
             let t = [];
             if (
               (1 == o &&
                 $("body").on("click", ".zoomycheck", function () {
                   console.log("....");
                   var o = $(this).attr("data-id"),
                     e = $(".zoomywishid-" + o).attr("data-handle"),
                     i = $(".zoomywishid-" + o).attr("data-variant"),
                     a = $(".zoomywishid-" + o).attr("data-variantname"),
                     s = $(".zoomywishid-" + o).attr("data-price"),
                     l = $(".zoomywishid-" + o).attr("data-title"),
                     r = $(".zoomywishid-" + o).attr("data-image");
                   if (
                     ((p = {
                       product_id: o,
                       product_handle: e,
                       vid: i,
                       vname: a,
                       proprice: s,
                       protitle: l,
                       proimage: r,
                     }),
                     null == localStorage.getItem("myzooomy__wishlist"))
                   );
                   else {
                     let o = localStorage.getItem("myzooomy__wishlist");
                     t = JSON.parse(o);
                   }
                   1 == $(".checkbox-" + o).prop("checked")
                     ? ($(".zooomywishmsg-" + o).replaceWith(
                         '<p class="zooomywishmsg zadbg zooomywishmsg-' +
                           o +
                           '" style="cursor:pointer;"><i class="fa  fa-' +
                           h +
                           '" aria-hidden="true"  ></i></p>'
                       ),
                       0 ==
                         t.filter(function (t) {
                           return t.product_id == o;
                         }).length && t.push(p),
                       $(".zwishfixed").append(
                         "<div class='" +
                           o +
                           "' style='width:25%;float:left;padding:10px;box-sizing:border-box;'><a class='rfw' data-id='" +
                           o +
                           "'>x</a><div class='' style=''><a href='https://" +
                           c +
                           "/products/" +
                           e +
                           "' target='_blank'><img src='" +
                           r +
                           "' width='100'/</a><div class='zall_details'><p><a href='https://" +
                           c +
                           "/products/" +
                           e +
                           "' target='_blank'>" +
                           l +
                           "</a></p><span class='wish_price money' >" +
                           s +
                           "</span><div class='zbtn'><a href='https://" +
                           c +
                           "/products/" +
                           e +
                           "' target='_blank'>View Product</a></div></div></div></div>"
                       ),
                       "happily-ever-a.myshopify.com" != c &&
                         $.ajax({
                           url: "https://zooomyapps.com/wishlist/ZooomyGuestWishlist.php",
                           data: {
                             shop: c,
                             productid: o,
                             title: l,
                             handle: e,
                             proimage: r,
                             price: s,
                             vname: a,
                           },
                           dataType: "jsonp",
                           jsonp: "guestdatacode",
                           async: "true",
                           success: function (o) {},
                         }))
                     : 0 == $(".checkbox-" + o).prop("checked") &&
                       ($(".zooomywishmsg-" + o).replaceWith(
                         '<p class="zooomywishmsg zrmvbg zooomywishmsg-' +
                           o +
                           '" style="cursor:pointer;"><i class="fa  fa-' +
                           h +
                           '-o" aria-hidden="true"  ></i></p>'
                       ),
                       (t = t.filter((t) => t.product_id != o)),
                       $("." + o).remove());
                   var n = JSON.stringify(t);
                   localStorage.setItem("myzooomy__wishlist", n),
                     $("#zooomy-wishlist-counter").length &&
                       (document.getElementById(
                         "zooomy-wishlist-counter"
                       ).innerHTML = "<span>" + t.length + "</span>"),
                     $(".zooomyIconval").length &&
                       (t.length > 0
                         ? $(".zooomyIconval i.fa")
                             .addClass("fa-heart")
                             .removeClass("fa-heart-o")
                         : $(".zooomyIconval i.fa")
                             .addClass("fa-heart-o")
                             .removeClass("fa-heart"));
                 }),
               null == localStorage.getItem("myzooomy__wishlist"))
             );
             else {
               let o = localStorage.getItem("myzooomy__wishlist"),
                 t = JSON.parse(o);
               $.each(t, function (o, t) {
                 var e = t.product_id;
                 (hearticon =
                   "<div class='zoomywishidheart' style='position:relative;'><input type='checkbox' data-id='" +
                   e +
                   "' class='zoomycheck checkbox-" +
                   e +
                   "'   id='checkbox-" +
                   e +
                   "' checked='true'/><label for ='checkbox-" +
                   e +
                   "'><p class='zooomywishmsg zadbg zooomywishmsg-" +
                   e +
                   "'><i class='fa fa-" +
                   h +
                   "' style='color: " +
                   s +
                   ";'></i></p></label</div>"),
                   $(".zoomywishid-" + e).html(hearticon),
                   $(".zwishfixed").append(
                     "<div class='" +
                       e +
                       "' style='width:25%;float:left;padding:10px;box-sizing:border-box;'><a class='rfw' data-id='" +
                       e +
                       "'>x</a><div class='' style=''><a href='https://" +
                       c +
                       "/products/" +
                       t.product_handle +
                       "' target='_blank'><img src='" +
                       t.proimage +
                       "' width='100'/</a><div class='zall_details'><p><a href='https://" +
                       c +
                       "/products/" +
                       t.product_handle +
                       "' target='_blank'>" +
                       t.protitle +
                       "</a></p><span class='wish_price money' >" +
                       t.proprice +
                       "</span><div class='zbtn'><a href='https://" +
                       c +
                       "/products/" +
                       t.product_handle +
                       "' target='_blank'>View Product</a></div></div></div></div>"
                   );
               });
             }
             if (
               $("#zooomy-wishlist-counter").length &&
               (null !== localStorage.getItem("myzooomy__wishlist") ||
                 null != localStorage.getItem("myzooomy__wishlist") ||
                 null != localStorage.getItem("myzooomy__wishlist"))
             ) {
               var y = JSON.parse(
                 localStorage.getItem("myzooomy__wishlist")
               ).length;
               document.getElementById("zooomy-wishlist-counter").innerHTML =
                 "<span>" + y + "</span>";
             }
             if ($(".zooomyIconval").length)
               (y = JSON.parse(
                 localStorage.getItem("myzooomy__wishlist")
               ).length) > 0
                 ? $(".zooomyIconval i.fa")
                     .addClass("fa-heart")
                     .removeClass("fa-heart-o")
                 : $(".zooomyIconval i.fa")
                     .addClass("fa-heart-o")
                     .removeClass("fa-heart");
           } else
             $("body").append(
               "<div class='zooomyloginrequest' id='zooomyloginrequestonce'><a href='https://" +
                 c +
                 "/account/login'>" +
                 n +
                 "</a> <span id='zloginrequestclose'><i class='fa fa-close'></i></span> </div>"
             ),
               $("#zooomyloginrequestonce").each(function () {
                 $('[id="' + this.id + '"]:gt(0)').remove();
               }),
               $("body").on("click", ".zoomywishid", function (o) {
                 $(this).attr("data-product-id");
                 $(".zooomyloginrequest").show("100"),
                   $(
                     "<style>.zooomyloginrequest a{color:" +
                       t.l_f_color +
                       ";text-decoration:none;}#zloginrequestclose .fa{color:#fff;}#zloginrequestclose{cursor: pointer; background: #000; color: #fff; border-radius: 62px; width: 20px; height: 20px; line-height: 20px; text-align: center; float: right; padding: 0; margin-left: 10px;}body{position:relative;}.zooomyloginrequest{z-index:99999;display:none;position: fixed; top: 0; right: 0; background: " +
                       t.l_b_color +
                       "; border: 1px solid " +
                       t.l_br_color +
                       "; padding: 17px;}</style>"
                   ).appendTo("body"),
                   $("#zloginrequestclose").click(function () {
                     $(".zooomyloginrequest").hide("100");
                   }),
                   $(document).ready(function () {
                     setTimeout(function () {
                       $(".zooomyloginrequest").fadeOut(1500);
                     }, 5e3);
                   });
               });
         if ("" != customerId) {
           if (null !== localStorage.getItem("myzooomy__wishlist"))
             if (null == localStorage.getItem("myzooomy__wishlist"));
             else {
               let o = localStorage.getItem("myzooomy__wishlist"),
                 t = JSON.parse(o);
               $.each(t, function (o, t) {
                 $.ajax({
                   url: "https://zooomyapps.com/wishlist/SaveData.php",
                   data: {
                     shop: shopId,
                     productid: t.product_id,
                     title: t.protitle,
                     handle: t.product_handle,
                     img: t.proimage,
                     price: t.proprice,
                     customerid: customerId,
                     customername: customerName,
                     customer_email: customerEmail,
                   },
                   dataType: "jsonp",
                   jsonp: "savedatacode",
                   async: "true",
                   success: function (o) {
                     data = data.filter((t) => t.product_id != o.productid);
                   },
                 });
               }),
                 localStorage.removeItem("myzooomy__wishlist");
             }
           1 == o &&
             $("body").on("click", ".zoomywishid", function (o) {
               var t = $(this).attr("data-product-id"),
                 e = $(".zoomywishid-" + t).attr("data-handle"),
                 i =
                   ($(".zoomywishid-" + t).attr("data-variant"),
                   $(".zoomywishid-" + t).attr("data-variantname"),
                   $(".zoomywishid-" + t).attr("data-price")),
                 a = $(".zoomywishid-" + t).attr("data-title"),
                 s = $(".zoomywishid-" + t).attr("data-image");
               return (
                 $(".zooomywishmsg-" + t + " i").is(".fa-" + h) &&
                   $(".zooomywishmsg-" + t).replaceWith(
                     '<p class="zooomywishmsg zrmvbg zooomywishmsg-' +
                       t +
                       '" style="cursor:pointer;"><i class="fa fa-' +
                       h +
                       '-o" aria-hidden="true"  ></i></p>'
                   ),
                 $(".zooomywishmsg-" + t + " i").is(".fa-" + h + "-o") &&
                   $(".zooomywishmsg-" + t).replaceWith(
                     '<p class="zooomywishmsg  zooomywishmsg-' +
                       t +
                       '" style="cursor:pointer;"><i class="fa fa-' +
                       h +
                       '" aria-hidden="true"  ></i></p>'
                   ),
                 $.ajax({
                   url: "https://zooomyapps.com/wishlist/CollCheck.php",
                   data: {
                     shop: shopId,
                     productid: t,
                     customerid: customerId,
                     title: a,
                     handle: e,
                     img: s,
                     price: i,
                     cval: m,
                     customer_name: customerName,
                   },
                   dataType: "jsonp",
                   jsonp: "mylinkprocode",
                   async: "true",
                   success: function (o) {
                     var t = o.done,
                       e = o.productid;
                     if (
                       "done" == t &&
                       ($(".checkbox-" + e).prop("checked", !0),
                       $(".zooomywishmsg-" + e).replaceWith(
                         '<p class="zooomywishmsg zadbg zooomywishmsg-' +
                           e +
                           '" style="cursor:pointer;"><i class="fa  fa-' +
                           h +
                           '" aria-hidden="true"  ></i></p>'
                       ),
                       $("#zooomy-wishlist-counter").length)
                     ) {
                       const o = document.getElementById(
                         "zooomy-wishlist-counter"
                       );
                       var i = parseInt(o.innerText);
                       (i += 1),
                         (document.getElementById(
                           "zooomy-wishlist-counter"
                         ).innerHTML = "<span>" + i + "</span>");
                     }
                     if (
                       "ndone" == t &&
                       ($(".checkbox-" + e).prop("checked", !1),
                       $(".zooomywishmsg-" + e).replaceWith(
                         '<p class="zooomywishmsg zrmvbg zooomywishmsg-' +
                           e +
                           '" ><i class="fa  fa-' +
                           h +
                           '-o" aria-hidden="true" ></i> </p>'
                       ),
                       $("#zooomy-wishlist-counter").length)
                     ) {
                       const o = document.getElementById(
                         "zooomy-wishlist-counter"
                       );
                       var a = parseInt(o.innerText);
                       (a -= 1),
                         (document.getElementById(
                           "zooomy-wishlist-counter"
                         ).innerHTML = "<span>" + a + "</span>");
                     }
                     $(".zooomyIconval").length &&
                       (newtotalval > 0
                         ? $(".zooomyIconval i.fa")
                             .addClass("fa-heart")
                             .removeClass("fa-heart-o")
                         : $(".zooomyIconval i.fa")
                             .addClass("fa-heart-o")
                             .removeClass("fa-heart"));
                   },
                 }),
                 o.stopPropagation(),
                 !1
               );
             });
         } else
           $("body").on("click", ".zoomywishid", function (o) {
             $(this).attr("data-product-id");
           });
       },
     });
   }
   r(n),
     $("#zooomy-wishlist-counter").length &&
       setTimeout(function () {
         var o = document.getElementById("zooomy-wishlist-counter").innerHTML;
         ("00" != o && "" != o) ||
           (document.getElementById("zooomy-wishlist-counter").innerHTML =
             "<span>0</span>");
       }, 300),
     $(window).scroll(function () {
       t.length > 0 &&
         (clearTimeout($.data(this, "scrollTimer")),
         $.data(
           this,
           "scrollTimer",
           setTimeout(function () {
             let o = [],
               t = "",
               e = $(".zoomywishid:not([data-zooomy-initialized])");
             $(e).each(function () {
               "" == $(this).html().trim() &&
                 ((t = $(this).attr("data-product-id")), o.push(t));
             });
             if (o.length > 0) {
               n++;
               r(n);
             }
           }, 300)
         ));
     });
 }
};

function reqJquery() {
 if (
   "undefined" == typeof jQuery ||
   !jQuery ||
   (1 === parseInt(jQuery.fn.jquery) &&
     11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, "")))
 ) {
   var o = document.getElementsByTagName("head")[0],
     t = document.createElement("script");
   (t.src =
     "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js"),
     (t.type = "text/javascript"),
     (t.onload = t.onreadystatechange =
       function () {
         t.readyState
           ? ("complete" !== t.readyState && "loaded" !== t.readyState) ||
             ((t.onreadystatechange = null), zooomyColl(jQuery.noConflict(!0)))
           : zooomyColl(jQuery.noConflict(!0));
       }),
     o.appendChild(t);
 } else zooomyColl(jQuery);
}

"product" == meta.page.pageType ? setTimeout(reqJquery, 2e3) : reqJquery();

window.reinitializeZoomyWishlist = function () {
 window.icallofzColl = 0;
 if (typeof reqJquery === "function") {
   reqJquery();
 }
};